import '@fancyapps/fancybox'
import { fancyData } from './configs'

let { fancyDefaultOptions, fancyCustomElements } = fancyData


/**
 * Set some default options
 */
jQuery.fancybox.defaults = { ...jQuery.fancybox.defaults, ...fancyDefaultOptions }


/**
 * Apply custom elements
 */
fancyCustomElements.forEach(node => {
	jQuery(node.selector).fancybox(node.options)
})
